export default "__VITE_ASSET__CPCdjtM0__"